<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-toolbar flat color="transparent" height="50">
                    <h3 class="hidden-sm-and-down">Danh sách khách hàng ({{totalAccount}})</h3>
                    <h4 class="hidden-md-and-up">Khách hàng ({{totalAccount}})</h4>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        dark
                        v-if="loggedUser.isProvider || loggedUser.isDistributor"
                        class="hidden-sm-and-down"
                        to="/account/add"
                    >
                        Tạo khách hàng
                        <v-icon right dark>person_add</v-icon>
                    </v-btn>
                    <v-btn
                      color="green"
                      dark
                      v-if="loggedUser.isProvider"
                      class="hidden-sm-and-down"
                      to="/account/import"
                    >
                        Nhập đại lý
                        <v-icon right dark>group_add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-flex lg12>
                    <account-table 
                      :isLoading="isLoading" 
                      :datasource="accounts" 
                      :totalItems="totalAccount" 
                      @changePage="changePage" 
                      @exportFile="openDialogExportFile"
                      @updateDtCode="updateDtCode"  
                    />
                </v-flex>
            </v-layout>
        </v-container>
        <v-speed-dial
            bottom
            right
            fixed
            class="hidden-md-and-up"
            v-model="fab"
            v-if="loggedUser.isProvider"
        >
            <v-btn slot="activator" color="red" dark fab v-model="fab">
                <v-icon>add</v-icon>
                <v-icon>close</v-icon>
            </v-btn>
            <v-btn fab dark small color="green" to="/account/import">
                <v-icon>group_add</v-icon>
            </v-btn>
            <v-btn fab dark small color="primary" to="/account/add">
                <v-icon>person_add</v-icon>
            </v-btn>
        </v-speed-dial>

      <!-- Dialog xuất file -->
      <dialog-export-file ref="dialogExportFile" :loading="loadingExportFile" @export="handleExportFile"/>
      <!-- Dialog xuất file -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import AccountTable from './components/list';
import DialogExportFile from '@/components/dialog/DialogExportFile';
import XLSX from 'xlsx';

export default {
  components: {
    AccountTable,
    DialogExportFile
  },
  data () {
    return {
      isLoading: false,
      fab: false,
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10,
        filter: ''
      },
      accounts: [],
      loadingExportFile: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser', 'totalAccount']),
  },
  created () {
    // code
  },
  methods: {
    ...mapActions(['getAccounts', 'createDtMapping', 'getDtMapping']),
    // changePage (pagination) {
    //   this.isLoading = true;
    //   this.pagination = { ...pagination };
    //   this.getAccounts(this.pagination).then(res => {
    //     this.accounts = res;
    //     this.isLoading = false;
    //   });
    // },
    async changePage (pagination) {
      this.isLoading = true;
      this.pagination = { ...pagination };

      let accounts = await this.getAccounts(this.pagination);

      let dtMap = await this.getDtMapping()
        .then(res => res.data || [])
        .catch(_ => []);

      let mapByAccount = {};
      dtMap.forEach(x => {
        mapByAccount[x.accountId] = x.code;
      });

      accounts = accounts.map(acc => ({
        ...acc,
        dtCode: mapByAccount[acc.id] || ''
      }));

      this.accounts = accounts;
      this.isLoading = false;
    },

    openDialogExportFile () {
      let fileName = `Accounts-${this.pagination.filter}`;
      let countExportFile = Math.ceil(this.totalAccount / 10000);
      this.$refs.dialogExportFile.open(countExportFile, fileName);
    },

    async handleExportFile (file) {
      let params = {
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000,
        filter: this.pagination.filter
      };

      this.loadingExportFile = true;

      let list = await this.getAccounts(params).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      list.map(item => {
        let account = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.name,
          'username': item.username,
          'SĐT': item.phone,
          'Email': item.email,
          'Số lượng xe': item.vehicle,
          'Số lượng thiết bị': item.device,
          'Số lượng simcard': item.sim,
          'Là Nhà phân phối': item.isDistributor,
          'Là Đại lý': item.isDealer,
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10),
          'Lần chỉnh sửa cuối': new Date(item.modifiedDate)
            .toISOString()
            .slice(0, 10)
        };
        dataToExport.push(account);
        return 0;
      });

      let sheet = XLSX.utils.json_to_sheet(dataToExport);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'Accounts');
      XLSX.writeFile(wb, `${file.name}.xlsx`);      
    },

    async updateDtCode ({ id, dtCode }) {
      this.isLoading = true;

      try {
        await this.createDtMapping({
          accountId: id,
          code: dtCode
        });

        window.getApp.showMessage("Cập nhật DT Code thành công", "success");

        this.changePage(this.pagination); // reload data
      } catch (err) {
        console.error(err);
        window.getApp.showMessage("Lỗi cập nhật DT Code", "error");
      }

      this.isLoading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/account/index.vue